<template>
  <div class="scroll-container" ref="scrollContainer" @scroll="handleScroll">
    <a-row :gutter="[20, 20]">
      <a-col v-for="(item, index) in planList" :key="index" :span="8" class="plan-card">
        <a-card :bordered="false" style="border-radius: 5px; background-color: #f8fafc">
          <div class="flex-between">
            <div>
              <div class="flex-align-center">
                <span class="title-2" style="margin-right: 5px">{{ item.title }}</span>
                <div class="right-icon flex-center" @click="showPlanDetail(item)">
                  <a-icon type="right" style="font-size: 12px; color: #fff" />
                </div>
              </div>
              <div style="margin: 12px 0">
                <a-tag :color="['orange', 'blue'][item.tag]">
                  {{ ['测评', '活动'][item.tag] }}
                </a-tag>
                <a-tag :color="item.color">
                  {{ getDictCodeData(item.status) }}
                </a-tag>
                <!-- 管理员和非管理员自己创建且不为进行中的可删除-->
                <span
                  v-show="
                    userInfo().username == 'admin' ||
                    (userInfo().username == item.createBy && item.status != 1)
                  "
                  class="action-icon transparent-area-appear"
                >
                  <a-icon
                    type="edit"
                    :style="{ fontSize: '18px', color: '#1783E8', marginRight: '10px' }"
                    @click.stop="editCard(item)"
                  />
                  <a-popconfirm title="是否删除该卡片？" @confirm="deleteCard(item, index)">
                    <a-icon type="delete" :style="{ fontSize: '18px', color: '#FF4D4F' }" />
                  </a-popconfirm>
                </span>
              </div>
              <div>
                活动日期:
                <span v-if="item.beginDate && item.endDate">
                  {{ item.beginDate }} 至 {{ item.endDate }}
                </span>
                <span v-else>无</span>
              </div>
            </div>
            <a-progress
              type="circle"
              :width="100"
              :strokeColor="item.color"
              :percent="Number(item.rate)"
            >
              <template #format="percent">
                <div>
                  <div style="font-size: 20px; font-weight: bold">{{ percent }}%</div>
                  <div style="margin-top: 10px; font-size: 13px">班级参与率</div>
                </div>
              </template>
            </a-progress>
          </div>
        </a-card>
      </a-col>
      <a-col>
        <EmptyData :dataSource="planList" :styleObj="{ padding: '50px 0' }" :loading="loading" />
      </a-col>
    </a-row>
    <CreatePlan ref="createPlanRef" @refreshData="refreshData" />
  </div>
</template>
<script>
import CreatePlan from '@/comUi/CreatePlan'
import { getDictCodeData } from '@/utils/util'
import { deleteAction, getAction } from '@api/manage'
import { mapGetters } from 'vuex'

export default {
  name: 'PlanCard',
  components: {
    CreatePlan,
  },
  props: {
    planType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      planList: [],
      scrollContainer: null,
      scrollHeight: 0,
      scrollTop: 0,
      scrollBottom: 0,
      scrollLeft: 0,
      scrollRight: 0,
      scrollWidth: 0,
      scrollX: false,
      scrollY: false,
      scrollXDirection: '',
      scrollYDirection: '',
      scrollXDistance: 0,
      scrollYDistance: 0,
      pageNo: 1,
      pageSize: 20,
      loading: false,
      evalTotal: 0,
      activityTotal: 0,
      canceled: false,
      cancelTokens: new Map(),
    }
  },
  watch: {
    planType: {
      handler() {
        this.pageNo = 1
        this.evalTotal = 0
        this.activityTotal = 0
        this.planList = []
        this.getPlanList().finally(() => {
          this.loading = false
        })
      },
      immediate: true,
    },
    loading: {
      handler(val) {
        // 当loading状态变化时通知父组件
        this.$emit('loadingChange', val)
      },
      immediate: true,
    },
  },
  methods: {
    ...mapGetters(['userInfo']),
    // 获取计划数据
    getPlanList() {
      this.loading = true
      switch (this.planType) {
        case 0:
          return Promise.all([this.getEvalPlan(), this.getActivityPlan()])
        case 1:
          return this.getActivityPlan()
        case 2:
          return this.getEvalPlan()
      }
    },
    async getEvalPlan() {
      const res = await getAction('/schoolEvaluationPlan/list', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
      const { success, result } = res
      if (success) {
        const planList = result.records.map((item) => {
          return {
            ...item,
            title: item.name,
            time: item.createTime,
            rate: new Number((item.finishClassNum / item.planClassNum)* 100).toFixed(2) ,
            color: '#1783E8',
            tag: 0,
          }
        })
        this.evalTotal = result.total
        this.planList.push(...planList)
      }
    },
    async getActivityPlan() {
      const res = await getAction('/schoolActivityPlan/list', {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
      const { success, result } = res
      if (success) {
        const planList = result.records.map((item) => {
          return {
            ...item,
            time: item.createTime,
            rate: (item.finishClassNum / item.planClassNum).toFixed(2) * 100,
            color: '#1783E8',
            tag: 1,
          }
        })
        this.activityTotal = result.total
        this.planList.push(...planList)
      }
    },
    handleScroll() {
      const container = this.$refs.scrollContainer
      // 检查是否滚动到底部
      const isScrollBottom = container.scrollTop + container.clientHeight >= container.scrollHeight
      if (isScrollBottom && this.evalTotal + this.activityTotal > this.planList.length) {
        this.pageNo += 1
        this.loading = true
        this.getPlanList().finally(() => {
          this.loading = false
        })
      }
    },
    getDictCodeData(status) {
      return getDictCodeData('assessment_status', status).text || ''
    },
    createPlan() {
      this.$refs.createPlanRef.showModal()
      // this.$refs.createCourseModalRef.showModal()
    },
    editCard(item) {
      this.$refs.createPlanRef.showModal(item)
    },
    async deleteCard(item, index) {
      const urlArr = ['/schoolEvaluationPlan', '/schoolActivityPlan']
      const res = await deleteAction(`${urlArr[item.tag]}/delete`, { id: item.id })
      if (res.success) {
        this.$message.success(res.message)
        this.planList.splice(index, 1)
        return
      }
      this.$message.error(res.message)
    },
    showPlanDetail(data) {
      console.log('跳转信息：', data)
      this.$router.push({
        path: '/school/mentalHealth/PlanDetails',
        query: {
          id: data.id,
          tag: data.tag,
          title: data.title,
          gradeIds: data.gradeIds,
          classIds: data.classIds,
        },
      })
    },
    refreshData(data) {
      console.log('刷新数据：', data)
      // 新增
      if (!data.id) {
        this.pageNo = 1
        this.planList = []
        this.getPlanList().finally(() => {
          this.loading = false
        })
        return
      }
      // 编辑
      const findIndex = this.planList.findIndex((pItem) => pItem.id === data.id)
      console.log('findIndex', findIndex)
      if (findIndex === -1) return
      this.$set(this.planList, findIndex, {
        ...data,
        title: data.name || data.title,
      })
      console.log('计划列表：', this.planList)
    },
  },
}
</script>
<style scoped lang="less">
.head-card-box {
  min-height: 135px;
  color: #fff;
  border-radius: 15px;
  padding: 0px 20px;
}

.row-box {
  padding: 10px !important;
  padding-bottom: 0 !important;
  border-radius: 10px;
  background-color: #fff;
}

.title-margin {
  margin-top: 10px;
  margin-bottom: 15px;
}

.card-content {
  display: flex;
  justify-content: space-between;

  .card-item {
    // flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    .item-value {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 2px;
    }

    .item-desc {
      font-size: 14px;
    }
  }
}

.key-point-item {
  height: 140px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  cursor: pointer;
}

.number-value {
  font-size: 30px;
  font-weight: bold;
  color: #fff;
  border-radius: 5px;
}

.plan-card {
  /deep/ .ant-card-body {
    padding: 12px;
  }
}

.scroll-container {
  height: 76vh; /* 设置一个固定高度 */
  padding: 0 5px;
  overflow: hidden;
  overflow-y: scroll; /* 启用垂直滚动 */
}

.right-icon {
  width: 18px;
  height: 18px;
  background-color: #d7d9d9;
  border-radius: 50%;
  cursor: pointer;
}
</style>
